import { useTheme } from '@material-ui/styles';
import { IChartApi } from 'lightweight-charts';
import React, { useEffect } from 'react';
import { GetDividendDetailQuery } from 'site/graphql';

const chartContainerId = 'dividend-detail-candles-chart';

type IDividendDetailCandlesChartProps = {
    candles: GetDividendDetailQuery['dividend']['candles'];
    className?: string;
};

const DividendDetailCandlesChart: React.FC<IDividendDetailCandlesChartProps> = ({ candles, className }) => {
    const theme = useTheme();
    const { accent, green } = theme.colors;

    useEffect(() => {
        let chart: IChartApi = null;

        // Падает с ошибкой на SSR, поэтому динамический импорт в useEffect
        // https://github.com/tradingview/lightweight-charts/issues/446
        import(/* webpackChunkName: "lightweight-charts" */ 'lightweight-charts').then(
            ({ createChart, CrosshairMode }) => {
                const container = document.getElementById(chartContainerId);

                chart = createChart(container, {
                    width: container.offsetWidth,
                    height: 300,
                    crosshair: {
                        mode: CrosshairMode.Magnet,
                    },
                    localization: {
                        locale: 'ru-RU',
                    },
                });

                const candleSeries = chart.addCandlestickSeries({
                    downColor: accent,
                    borderDownColor: accent,
                    wickDownColor: accent,
                    upColor: green,
                    borderUpColor: green,
                    wickUpColor: green,
                });
                candleSeries.setData(candles);
            },
        );

        const onResize = () => {
            if (chart) {
                const newWidth = document.getElementById('dividend-detail-candles-chart').offsetWidth;
                chart.resize(newWidth, 300);
            }
        };

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [candles]);

    return <div id={chartContainerId} className={className} />;
};

export default DividendDetailCandlesChart;
